<template>
  <!-- Page content -->
  <div
    class="container-fluid py-5 card-login"
    v-bind:style="{
      backgroundImage:
        'linear-gradient(to top, ' + $THEME
          ? $THEME.primaryColor
          : '#0b9dd1' + ', #ffffff)',
    }">
    <div class="row justify-content-center h-100 align-items-center">
      <div class="col-12 col-xl-5 col-lg-6 col-md-7 login-600">
        <div class="card bg-secondary shadow border-0">
          <div class="card-header bg-transparent pb-5">
            <img src="img/brand/logo.png" className="logo" />
            <small>v.1.0.0</small>
          </div>
          <BlockUI v-if="busy">
            <div class="loader"></div>
          </BlockUI>
          <div class="card-body px-lg-5 py-lg-5">
            <h3 class="text-muted pb-2">เข้าสู่ระบบ</h3>
            <form @submit="handleSubmit">
              <div class="form-group material-floater">
                <input
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                  v-model="email"
                  required />
                <label floater>E-Mail</label>

                <!-- Vuelidate -->
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback position-absolute">
                  <span v-if="!$v.email.required">กรุณากรอกอีเมล์</span>
                  <span v-if="!$v.email.email">รูปแบบอีเมล์ไม่ถูกต้อง</span>
                </div>
              </div>

              <div class="form-group material-floater">
                <input
                  class="form-control"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                  placeholder=""
                  type="password"
                  autocomplete="on"
                  v-model="password"
                  required />
                <label floater>Password</label>
                <div
                  v-if="submitted && $v.password.$error"
                  class="invalid-feedback position-absolute">
                  <span v-if="!$v.password.required">กรุณากรอกรหัสผ่าน</span>
                  <span v-if="!$v.password.minLength"
                    >กรุณากรอก"รหัสผ่าน"อย่างน้อย
                    {{ $v.password.$params.minLength.min }} ตัวอักษร</span
                  >
                </div>
              </div>

              <div class="text-center">
                <button type="submit" class="my-4 btn btn-info btn-icon">
                  Sign in
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
    <ModalNotification :notiShop="noti" />
  </div>
</template>

<script>
import JwtDecode from "jwt-decode";
import validatePop from "../plugins/validatePop.js";
import ModalNotification from "@/components/custom/ModalNotification";
import setLocalStorage from "@/constants/LocalStorageManagement";
import { required, email, minLength } from "vuelidate/lib/validators";
const API_URL = process.env.VUE_APP_API;

export default {
  name: "login",
  components: {
    ModalNotification,
  },
  data() {
    return {
      popVersion: process.env.VUE_APP_VERSION,
      email: null,
      password: null,
      submitted: false,
      busy: false,
      noti: {
        show: false,
        type: "",
        created_by: "",
        role: "",
        date_noti: "",
        router: true,
      },
      userLogin: "",
    };
  },

  validations: {
    email: {
      required,
      email,
    },
    password: {
      required,
      minLength: minLength(3),
    },
  },
  mounted() {
    const currentURL = window.location.href;
    const httpPatt = /^http:\/\//gi;
    if (httpPatt.test(currentURL) && !process.env.VUE_APP_HTTP) {
      window.location = currentURL.replace(httpPatt, "https://");
    }
  },
  methods: {
    handleSubmit(e) {
      this.busy = true;
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        this.busy = false;
        return false;
      }
      e.preventDefault();
      if (this.password.length > 0) {
        this.$http
          .post(API_URL + "/login", {
            email: this.email,
            password: this.password,
          })
          .then((response) => {
            // console.log( response )
            let checkError = validatePop(response);
            if (!checkError.status) {
              if (checkError.notices == "token is expired") {
                this.$router.push("/logout");
              }
              this.busy = false;
              this.showErrorModal(checkError.msg);
              return false;
            }
            if (response.data.data) {
              let resLocalStorage = setLocalStorage.setLogin(
                response.data.data
              );
              this.$WALLET = response.data.data.wallet;
              this.checkStatusShop().then((res) => {
                let status_shop = res.data.data.status_shop;
                let created_by = res.data.data.created_by;
                setLocalStorage.createdBy().set(created_by);
                if (
                  status_shop == "LOCK" ||
                  (status_shop == "DEBT" && created_by != "superadmin")
                ) {
                  this.noti.created_by = created_by;
                  this.noti.date_noti = res.data.data.date_noti;
                  this.noti.type = status_shop;
                  this.noti.role = resLocalStorage.user.role;
                  this.noti.show = true;
                } else {
                  if (
                    resLocalStorage.user.role === "superadmin" ||
                    resLocalStorage.user.role === "shippop"
                  ) {
                    // this.$router.push("/dashboardshippop");
                    this.$router.push("/transports");
                  } else if (resLocalStorage.user.role === "master") {
                    this.$router.push("/reportbrance");
                  } else {
                    this.$router.push("/");
                  }
                }
                this.busy = false;
              });
            } else {
              if (response.data.error) {
                this.busy = false;
              }
            }
          })
          .catch((error) => {
            this.busy = false;
            // console.error(error.response);
            if (error.response.status >= 500) {
              this.showErrorModal(
                "โปรดรอสักครู่ ขณะนี้มีการปรับปรุงระบบ ขออภัยในความไม่สะดวก"
              );
            } else {
              this.showErrorModal("พบปัญหาการเชื่อมต่อ กรุณาติดต่อ...");
            }
          });
      }
    },
    checkStatusShop() {
      return new Promise((resolve) => {
        this.$http
          .get(API_URL + "/shop/noti", {
            headers: {
              Token: localStorage.getItem("access_token"),
            },
          })
          .then((res) => {
            let checkError = validatePop(res);
            if (!checkError.status) {
              if (checkError.notices == "token is expired") {
                this.$router.push("/logout");
              }
              this.showErrorModal(checkError.msg);
              this.busy = false;
              return false;
            }
            resolve(res);
          })
          .catch(() => {
            this.showErrorModal("พบปัญหาการเชื่อมต่อ กรุณาติดต่อ...");
          });
      });
    },
    showErrorModal(msgBody) {
      this.$bvModal.msgBoxOk(msgBody, {
        title: "ERROR",
        size: "sm",
        buttonSize: "sm",
        okVariant: "danger",
        okTitle: "ลองอีกครั้ง",
        contentClass: "modal-errors",
        headerClass: "p-2 border-bottom-0",
        footerClass: "p-2 border-top-0",
        centered: true,
      });
    },
  },
};
</script>

<style></style>
